import * as React from "react";
import * as FontAwesome from "react-fontawesome";
import Dialog from "material-ui/Dialog";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

type Props = {
  fraudStatus: string;
  popoverContents?: JSX.Element;
  children?: JSX.Element;
  classes?: any;
};

type State = { dialogOpen: boolean; el: any };

const styles = (theme) => ({
  paper: {
    padding: "10px",
  },
});

class FraudStatusIcon extends React.Component<Props, State> {
  state = {
    dialogOpen: false,
    el: null,
  };

  icon() {
    switch (this.props.fraudStatus) {
      case "monitored":
        return <FontAwesome name="eye" />;
      case "whitelisted":
        return <FontAwesome name="check" style={{ color: "green" }} />;
      case "blacklisted":
        return <FontAwesome name="minus-circle" style={{ color: "red" }} />;
      default:
        return <FontAwesome name="meh-o" />;
    }
  }

  handlePopoverOpen = (event) => {
    this.setState({ el: event.currentTarget });
  };

  handlePopoverClose = () => {
    this.setState({ el: null });
  };

  render() {
    const { children, classes } = this.props;
    return (
      <div>
        <span
          aria-owns={!!this.state.el ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          onMouseEnter={this.handlePopoverOpen}
          onMouseLeave={this.handlePopoverClose}
          onClick={() => {
            if (children) {
              this.setState({ dialogOpen: true });
            }
          }}
        >
          {this.icon()}
        </span>
        <Popover
          id="mouse-over-popover"
          open={!!this.state.el}
          anchorEl={this.state.el}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          classes={{
            paper: classes.paper,
          }}
          style={{ pointerEvents: "none" }}
        >
          {this.props.popoverContents || (
            <Typography>{this.props.fraudStatus || "none"}</Typography>
          )}
        </Popover>
        <Dialog
          title="Device fraud status"
          autoScrollBodyContent={true}
          contentStyle={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "none",
          }}
          modal={false}
          open={this.state.dialogOpen}
          onRequestClose={() => {
            this.setState({ dialogOpen: false });
          }}
        >
          {children}
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(FraudStatusIcon);
